import React from 'react';
import styled from "styled-components";
import Statistic from "../Statistic/Statistic";
import GoAroundMain from "../go-aroung/goAroundMain";
import StatisticPhoto from "../Statistic/Photo/StatisticPhoto";
import ToDoMain from "../ToDo/ToDoMain";



const WorkPlaceMainDiv=styled.div`
        width: 100%;
        height: 100%;        
        background-size: cover;
        overflow-block: scroll;         
    `
const WorkPlace = ({selectedSubPage, setSelectedSubPage}) => {
    const SubPages={
        Rundgang:{Action:<GoAroundMain/>},
        Statistic:{Action:<Statistic/>},
        Photo:{Action:<StatisticPhoto/>},
        ToDo:{Action:<ToDoMain/>}
        // ReadQR:{Action:<ReadQR setSelectedSubPage={setSelectedSubPage}/>},
        // ReadNFC:{Action:<NfcReader/>},
        // Storage:{Action:<Storage/>},
        // "Add subsidiary":{Action:<AddSubsidiary/>},
        // "Show subsidiaries":{Action:<ShowSubsidiaries setSelectedSubPage={setSelectedSubPage}/>},
        // "Show Subsidiary":{Action:<SubsidiaryPage setSelectedSubPage={setSelectedSubPage}/>},
        // Settings:{Action:<Settings/>},
        //     "Rights":{Action:<AddRightsSchema/>}
    }
    // console.log(selectedSubPage)
    return (
        <WorkPlaceMainDiv id={"WorkPlaceMainDiv"}>
            {selectedSubPage?SubPages[selectedSubPage].Action:""}
        </WorkPlaceMainDiv>
    );
};

export default WorkPlace;